import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  const [activeId, setActiveId] = useState('all');

  return (
    <section className="py-8 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-5">
          <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
          <h2 className="text-lg font-heading font-semibold text-foreground-900">浏览分类</h2>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={cat.id === 'all' ? '/category' : `/category?tab=${cat.id}`}
              onClick={() => setActiveId(cat.id)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeId === cat.id
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}